import axios from 'axios';
import { loginreq, req,upload,getByobj ,captcha} from './axiosFun';
// 上传文件
export const upimg = (params) => { return upload("post", "/image/uploadImage", params) };
// 获取验证码
export const getCaptcha = (params) => { return captcha("get", "/common/captcha", params) };
// 登录接口 
export const login = (params) => { return loginreq("post", "/auth/login", params) };
// 获取用户菜单
export const menu = (params) => { return axios.get("/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = () => { return req("post","/auth/logout") };
// 首页新增图片
export const addImgForm = (params) => { return req("post", "/homeRotation/insert", params) };
// 首页查询图片列表
export const indexImgList = (params) => { return getByobj("get", "/homeRotation/listByPage", params) };
// 首页修改图片列表
export const updateImgForm = (params) => { return req("post", "/homeRotation/update", params) };
// 首页新增图片
export const delImgForm = (params) => { return req("post", "/homeRotation/delete", params) };
// 首页禁用图片
export const imgLock = (params) => { return req("post", "/homeRotation/enableAndDisable", params) };
/**
 * 用户管理 
 **/

// 小程序用户列表
export const appUserList = (params) => { return getByobj("get", "/appUser/listByPage", params) };
// 系统用户列表
export const sysUserList = (params) => { return getByobj("get", "/role/listByPage", params) };
// 系统用户新增
export const addSysUser = (params) => { return req("post", "/role/insert", params) };
// 系统用户修改
export const editSysUser = (params) => { return req("post", "/role/update", params) };
// 系统用户删除
export const delSysUser = (params) => { return req("post", "/role/deleteById", params) };
// 系统角色权限修改
export const updateSysUserRules = (params) => { return req("post", "/role/updateRules", params) };
// 根据id查询系统系统用户
export const findSysUserById = (params) => { return req("get", "/role/findById", params) };
// 系统用户集合
export const getSysUserList = (params) => { return getByobj("get", "/role/getRoleList", params) };
// 系统vip用户
export const getVipUserList = (params) => { return getByobj("get", "/vipUser/listByPage", params) };

/**
 * 用户管理 
 **/
// 用户管理-获取用户列表
export const userList = (params) => { return getByobj("get", "/sysUser/listByPage", params) };
// 用户管理-保存
export const userSave = (params) => { return req("post", "/sysUser/insert", params) };
// 用户管理-编辑
export const userEdit = (params) => { return req("post", "/sysUser/update", params) };
// 个人信息-修改密码
export const userPwdEdit = (params) => { return req("post", "/sysUser/updatePwd", params) };
// 个人信息-根据id查询
export const userFindById = (params) => { return req("get", "/sysUser/findById/"+ params) };
// 个人信息-根据token查询
export const sysUserInfo = () => { return req("get", "/sysUser/info") };
// 用户管理-删除用户
export const userDelete = (params) => { return req("post","/sysUser/deleteById?id=" + params)};
// 用户管理-启用禁用
export const userLock = (params) => { return req("post", "/sysUser/enableAndDisable", params) };
// 用户管理-重置密码
export const userPwd = (params) => { return req("post", "/User/pwd", params) };
// 用户管理-数据权限
export const UserDeptTree = (params) => { return axios.get("/UserDept/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限保存
export const UserDeptSave = (params) => { return req("post", "/UserDept/save", params) };
// 用户管理-获取部门设置
export const UserDeptdeptTree = (params) => { return axios.get("/UserDept/deptTree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-保存部门设置
export const UserChangeDept = (params) => { return req("post", "/User/change/dept", params) };
// 用户管理-用户下线
export const userExpireToken = (params) => { return req("get", "/User/expireToken/" + params, {}) };
// 用户管理-刷新缓存
export const userFlashCache = (params) => { return req("get", "/User/flashCache/" + params, {}) };
// 用户管理-刷新缓存
export const initPwd = (params) => { return req("post", "/sysUser/resetPwd" ,params) };

/**
 * 菜单管理
 **/
// 菜单管理-获取菜单Module/list
export const ModuleList = () => { return req("post", "/Module/list") };
// 菜单管理-根据菜单获取数据
export const ModuleGet = (params) => { return axios.get("/Module/get/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 菜单管理-获取父级菜单Module/nodes
export const ModuleNodes = (params) => { return req("post", "/Module/nodes", params) };
// 菜单管理-修改菜单
export const ModuleSave = (params) => { return req("post", "/Module/save", params) };
// 菜单管理-删除菜单
export const ModuleDelete = (params) => { return axios.delete("/Module/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 角色管理 
 **/

// 角色管理-获取角色列表
export const roleGather = (params) => { return req("get", "/role/getRoleList", params) };
// 角色管理-获取角色列表
export const roleList = (params) => { return req("post", "/Role/list", params) };
// 角色管理-保存（添加编辑）
export const roleSave = (params) => { return req("post", "/Role/save", params) };
// 角色管理-删除角色
export const roleDelete = (params) => { return axios.delete("/Role/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => { return axios.get("/RoleRight/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return req("post", "/RoleRight/save", params) };
// 角色管理-菜单权限根据角色id查询
export const getRolesById = (params) => { return req("get", "/role/findById/"+ params) };

/**
 * 公司管理 
 **/
// 公司管理-获取公司列表
export const deptList = (params) => { return req("post", "/Dept/list", params) };
// 公司管理-保存（添加编辑）
export const deptSave = (params) => { return req("post", "/Dept/save", params) };
// 公司管理-删除公司
export const deptDelete = (params) => { return axios.get("/Dept/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 系统环境变量 
 **/
// 系统环境变量-获取系统环境变量列表
export const variableList = (params) => { return req("post", "/Variable/list", params) };
// 系统环境变量-保存（添加编辑）
export const variableSave = (params) => { return req("post", "/Variable/save", params) };
// 系统环境变量-删除系统环境变量
export const variableDelete = (params) => { return axios.delete("/Variable/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 权限管理 
 **/
// 权限管理-获取权限列表
export const permissionList = (params) => { return req("post", "/Permission/list", params) };
// 权限管理-保存权限
export const ermissionSave = (params) => { return req("post", "/Permission/save", params) };
// 权限管理-删除权限
export const ermissionDelete = (params) => { return axios.delete("/Permission/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-获取权限
export const roleDropDown = () => { return axios.get("/Role/dropDown/all?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-配置权限
export const RolePermission = (params) => { return req("post", "/RolePermission/save", params) };


// WEBPACK FOOTER //
// ./src/api/userMG.js